<ion-button slot="icon-only" class="reaction" [disabled]="buttonConfig.disabled" (click)="onClick()">
  @if (!reaction?.inProgress) {
    <img [src]="buttonConfig.icon" [ngClass]="{ reacted: buttonConfig.reacted }" />
  }
  @if (reaction?.inProgress) {
    <ion-spinner name="crescent"></ion-spinner>
  }
</ion-button>
